import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Card,
  CardBody,
  Col,
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Label,
} from "reactstrap";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//Import Common Component
import {
  ErrorModal,
  RavenAgTable,
} from "components/Common/CombinedComponents";
import PageModalFooter from "components/Common/PageComponents/PageModalFooter";
import {getInitValue, getTitleValue, getDateTime, getInitValueTriple, getInitValueBoolean, 
  getBooleanValueCheckbox,} from "components/Common/TableComponents/AgTable/CellRenderers/CellFunctions";

import { Form, Formik, Field } from "formik";
import { withTranslation } from "react-i18next";

import RavenFormikField from "components/Common/RavenFormikField";
import {
  getDomesticBankList,
  getChargebackMonitoringList,
  getChargebackMonitoringSearch,
  getChargebackStatusDefList,
  chargebackMonitoringApiError
} from "../../store/actions";

import ChargebackMonitoringSearchContent from "./ChargebackMonitoringSearchContent"

const chargebackStatusName = {
  ResponseWaiting: "ResponseWaiting",
  MerchantAccepted: "MerchantAccepted",
  ResultWaiting: "ResultWaiting",
  BankAccepted: "BankAccepted",
  BankRefused: "BankRefused",
  Closed: "Closed"
 };

 const chargebackTypeName = {
  FraudTransaction: "FraudTransaction",
  UnknownTransaction: "UnknownTransaction",
  ProductServiceSupply: "ProductServiceSupply",
  ProductServiceError: "ProductServiceError",
  VoidRefundTransaction: "VoidRefundTransaction",
  DuplicateTransaction: "DuplicateTransaction",
  ContractReservationCancel: "ContractReservationCancel",
  DifferentAmount: "DifferentAmount",
  PaidOtherMethod: "PaidOtherMethod",
  Other: "Other",
  CardHolderRefundRequest: "CardHolderRefundRequest"
};

class ChargebackMonitoring extends Component {
  constructor(props) {
    super(props);

    this.state = {
      recordList: [],
      record: "",
      errorModal: false,
      addAnother: false,
      isedit: false,
      isDetail: false,
      recordcolumns: [
        {
          headerName: this.props.t("chargebackNumber"),
          field: "chargebackNumber",
        },
        {
          headerName: this.props.t("cardNo"),
          field: "cardNo",
        },
        {
          headerName: this.props.t("transactionAmount"),
          field: "transactionProvisionSettle.f004",
        },
        {
          headerName: this.props.t("chargebackAmount"),
          field: "chargebackAmount",
        },
        {
          headerName: this.props.t("currency"),
          field: "transactionProvisionSettle.f049",
        },
        {
          headerName: this.props.t("chargebackType"),
          field: "chargebackTypeDef.name",
          cellRenderer: (params) => {
            const { text } = this.getChargeBackTypeAndStatusByNameGrid(params.value, "type", "grid");
            return <span>{text}</span>;
          }
        },
        {
          headerName: this.props.t("chargebackDescription"),
          field: "chargebackDescription",
        },
        {
          headerName: this.props.t("chargebackStatus"),
          field: "chargebackStatusDef.name",
          cellRenderer: (params) => {
            const { text } = this.getChargeBackTypeAndStatusByNameGrid(params.value, "status", "grid");
            return <span>{text}</span>;
          }
        },
        {
          headerName: this.props.t("chargebackDate"),
          field: "chargebackDate",
          filter: "agDateTimeColumnFilter",
          hide: false,
          cellRenderer: "dateTimeCellRender",
          filterParams: { valueFormatter: getDateTime },
        },
        {
          headerName: this.props.t("transactionDate"),
          field: "transactionProvisionSettle.insertDateTime",
          filter: "agDateTimeColumnFilter",
          hide: false,
          cellRenderer: "dateTimeCellRender",
          filterParams: { valueFormatter: getDateTime },
        },
        {
          headerName: this.props.t("transactionEodDate"),
          field: "transactionProvisionSettle.eodDate",
          filter: "agDateTimeColumnFilter",
          hide: false,
          cellRenderer: "dateTimeCellRender",
          filterParams: { valueFormatter: getDateTime },
        },
        {
          headerName: this.props.t("f043cardAcceptorName"),
          field: "transactionProvisionSettle.f043cardAcceptorName",
        },
        {
          headerName: this.props.t("merchantNo"),
          field: "transactionProvisionSettle.subMerchantId",
        },
        {
          headerName: this.props.t("provisionNo"),
          field: "transactionProvisionSettle.f038",
        },
        {
          headerName: this.props.t("orderId"),
          field: "transactionProvisionSettle.orderId",
          cellClass: 'stringType' 
        },
        {
          headerName: this.props.t("paymentId"),
          field: "transactionProvisionSettle.paymentId",
          cellClass: 'stringType' 
        },
        {
          headerName: this.props.t("bankName"),
          field: "domesticBankDef.bankName",
        },
        {
          headerName: this.props.t("isPartialChargeback"),
          field: "isPartialChargeback",
          cellRenderer: "booleanCellRender",
          valueFormatter: getBooleanValueCheckbox,
          filterParams: {
            valueFormatter: getBooleanValueCheckbox
          }
        },
        {
          headerName: this.props.t("chargebackTransactionType"),
          field: "ravenTransactionTypeDef.description",
        },
        {
          headerName: this.props.t("chargebackEodDate"),
          field: "chargebackEodDate",
          filter: "agDateTimeColumnFilter",
          hide: true,
          cellRenderer: "dateTimeCellRender",
          filterParams: { valueFormatter: getDateTime },
        },
        {
          headerName: this.props.t("updateDateTime"),
          field: "updateDateTime",
          filter: "agDateTimeColumnFilter",
          hide: true,
          cellRenderer: "dateTimeCellRender",
          filterParams: { valueFormatter: getDateTime },
        },
      ],
    };

    this.toggle = this.toggle.bind(this);
    this.handleDetailClick = this.handleDetailClick.bind(this);
    this.SearchContent = this.SearchContent.bind(this);
  }

  //#region Base Operations
  componentDidMount() {
    this.props.apiError("");

    const { onGetRecordList, recordBankList, onGetBankList,onGetChargebackStatusList,recordChargebackStatusList} = this.props;
    onGetBankList({ userName: localStorage.getItem("username") });
    this.setState({ recordBankList });
    onGetChargebackStatusList();
    this.setState({ recordChargebackStatusList });
    onGetRecordList({ userName: localStorage.getItem("username") });
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    const { error } = this.props;
    if (prevProps.error !== error) {
      this.setState({ error: error });
    }
  }


  //#endregion

  //#region Cruid Operations

  handleAddRecordClick = () => {
    this.setState({ record: "", isEdit: false });
    this.toggle();
  };
  handleDetailClick = values => {

    this.setState({
      record: values,
      addAnother: false,
      isDetail: true,
      isEdit: false
    });
    this.toggle();
  };
  SearchContent() {
    return <ChargebackMonitoringSearchContent />
  }

  //#endregion

  //#region Dom Elements Design


  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
    if (this.state.modal) {
      setTimeout(() => this.setState({ isDetail: false }), 150);
    }
  }

  //#endregion

  getChargeBackTypeAndStatusByNameGrid = (name, typeOrStatus, gridOrModal) => {
    let text = "";

    if (typeOrStatus == "type") {
      switch (name) {
        case chargebackTypeName.FraudTransaction:
          text = "Kart Sahibine Ait Olmayan İşlem";
          break;
        case chargebackTypeName.UnknownTransaction:
          text = "Anlaşılamayan İşlem";
          break;
        case chargebackTypeName.ProductServiceSupply:
          text = "Gönderilmeyen Ürün";
          break;
        case chargebackTypeName.ProductServiceError:
          text = "Hatalı Ürün";
          break;
        case chargebackTypeName.VoidRefundTransaction:
          text = "İade Tutarı Alınamadı";
          break;
        case chargebackTypeName.DuplicateTransaction:
          text = "Mükerrer Çekim";
          break;
        case chargebackTypeName.ContractReservationCancel:
          text = "Sözleşme/Rezervasyon İptali";
          break;
        case chargebackTypeName.DifferentAmount:
          text = "Farklı Tutar Çekimi";
          break;
        case chargebackTypeName.PaidOtherMethod:
          text = "Farklı Ödeme Yöntemi";
          break;
        case chargebackTypeName.Other:
          text = "Diğer";
          break;
        case chargebackTypeName.CardHolderRefundRequest:
          text = "Kart Sahibi İade İsteği";
          break;
        default:
          text = name;
          break;
      }
    }else if(typeOrStatus == "status"){
      switch (name) {
        case chargebackStatusName.ResponseWaiting:
          text = "Is Yerinden Cevap Bekleniyor";
          break;
        case chargebackStatusName.MerchantAccepted:
          text = "Is Yeri Itirazi Kabul Etti";
          break;
        case chargebackStatusName.ResultWaiting:
          text = "Bankadan Cevap Bekleniyor";
          break;
        case chargebackStatusName.BankAccepted:
          text = "Banka Dokümani Kabul Etti";
          break;
        case chargebackStatusName.BankRefused:
          text = "Banka Dokümani Red Etti";
          break;
        case chargebackStatusName.Closed:
          text = "Itiraz Kapatildi";
          break;
        default:
          text = name;
          break;
      }
    }

    if (gridOrModal == "grid") {
      return { text: text };
    }
    else if (gridOrModal == "modal") {
      return text;
    }else{
      return name;
    }
  };

  

  render() {
    const { recordList } = this.props;
    const { record, error } = this.state;

    return (
      <React.Fragment>
        {error && (<ErrorModal errorMessage={error} onCloseModalClick={() => this.setState({ error: undefined })} />)}
        <ToastContainer />
        <div className="page-content">
          <Container fluid>
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <RavenAgTable
                      SearchContent={this.SearchContent}
                      onDetailClick={this.handleDetailClick}
                      actionItems={true}
                      exportOption={true}
                      recordcolumns={this.state.recordcolumns}
                      recordList={recordList}
                      breadCrumbTitle={this.props.t("pfMerchantManagement")}
                      breadCrumbItem={this.props.t("chargebackMonitoring")}
                    />
                    <Modal
                      isOpen={this.state.modal}
                      className={this.props.className}
                      onClose={this.toggleModalClose}
                      size="xl"
                      backdrop={"static"}
                      id="staticBackdrop"
                    >
                      <ModalHeader toggle={this.toggle} tag="h4">
                        {getTitleValue(this, "chargebackMonitoring")}
                      </ModalHeader>
                      <ModalBody>
                        <Formik
                          enableReinitialize={true}
                          initialValues={{
                            chargebackNumber: getInitValue(record, record.chargebackNumber),
                            cardNo: getInitValue(record, record.cardNo),
                            transactionAmount: getInitValueTriple(record, record.transactionProvisionSettle,record.transactionProvisionSettle?.f004),
                            chargebackAmount: getInitValue(record, record.chargebackAmount),
                            currency: getInitValueTriple(record, record.transactionProvisionSettle,record.transactionProvisionSettle?.f049),
                            chargebackType: this.getChargeBackTypeAndStatusByNameGrid(record.chargebackTypeDef?.name, "type", "modal"),
                            chargebackDescription:getInitValue(record, record.chargebackDescription),
                            chargebackStatus: this.getChargeBackTypeAndStatusByNameGrid(record.chargebackStatusDef?.name, "status", "modal"),
                            chargebackDate:getInitValue(record, record.chargebackDate).slice(0, 10),
                            insertDateTime: getInitValueTriple(record, record.transactionProvisionSettle, record.transactionProvisionSettle?.insertDateTime).slice(0, 10),
                            transactionEodDate: getInitValueTriple(record, record.transactionProvisionSettle, record.transactionProvisionSettle?.eodDate).slice(0, 10),
                            f043cardAcceptorName:getInitValueTriple(record, record.transactionProvisionSettle, record.transactionProvisionSettle?.f043cardAcceptorName),
                            merchantNo:getInitValueTriple(record, record.transactionProvisionSettle, record.transactionProvisionSettle?.subMerchantId),
                            provisionNo:getInitValueTriple(record, record.transactionProvisionSettle, record.transactionProvisionSettle?.f038),
                            orderId:getInitValueTriple(record, record.transactionProvisionSettle, record.transactionProvisionSettle?.orderId),
                            paymentId:getInitValueTriple(record, record.transactionProvisionSettle, record.transactionProvisionSettle?.paymentId),
                            f032:getInitValueTriple(record, record.domesticBankDef, record.domesticBankDef?.bankName),
                            isPartialChargeback: getInitValueBoolean(record, record.isPartialChargeback),
                            chargebackTransactionType:getInitValueTriple(record, record.ravenTransactionTypeDef,record.ravenTransactionTypeDef?.description),
                            chargebackEodDate:getInitValue(record, record.chargebackEodDate).slice(0, 10),
                          }}
                        >
                          {({ errors, touched }) => (
                            <Form>
                              <fieldset disabled={true}>
                                <Row>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"chargebackNumber"}
                                      label={"chargebackNumber"}
                                      type="text"
                                    />
                                  </Col>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"chargebackType"}
                                      label={"chargebackType"}
                                      type="text"
                                    />
                                  </Col>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"chargebackDescription"}
                                      label={"chargebackDescription"}
                                      type="text"
                                    />
                                  </Col>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"chargebackStatus"}
                                      label={"chargebackStatus"}
                                      type="text"
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"cardNo"}
                                      label={"cardNo"}
                                      type="text"
                                    />
                                  </Col>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"transactionAmount"}
                                      label={"transactionAmount"}
                                      type="text"
                                    />
                                  </Col>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"chargebackAmount"}
                                      label={"chargebackAmount"}
                                      type="text"
                                    />
                                  </Col>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"currency"}
                                      label={"currency"}
                                      type="text"
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"chargebackDate"}
                                      label={"chargebackDate"}
                                      type="text"
                                    />
                                  </Col>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"insertDateTime"}
                                      label={"transactionDate"}
                                      type="text"
                                    />
                                  </Col>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"transactionEodDate"}
                                      label={"transactionEodDate"}
                                      type="text"
                                    />
                                  </Col>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"f043cardAcceptorName"}
                                      label={"f043cardAcceptorName"}
                                      type="text"
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"merchantNo"}
                                      label={"merchantNo"}
                                      type="text"
                                    />
                                  </Col>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"provisionNo"}
                                      label={"provisionNo"}
                                      type="text"
                                    />
                                  </Col>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"orderId"}
                                      label={"orderId"}
                                      type="text"
                                    />
                                  </Col>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"paymentId"}
                                      label={"paymentId"}
                                      type="text"
                                    />
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"chargebackTransactionType"}
                                      label={"chargebackTransactionType"}
                                      type="text"
                                    />
                                  </Col>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"chargebackEodDate"}
                                      label={"chargebackEodDate"}
                                      type="text"
                                    />
                                  </Col>
                                  <Col lg={3} className="col-3">
                                    <RavenFormikField
                                      errors={errors}
                                      touched={touched}
                                      name={"f032"}
                                      label={"bankName"}
                                      type="text"
                                    />
                                  </Col>
                                  <Col lg={3} className="col-3">
                                    <div className="form form-check form-switch form-switch-md">
                                      <Label md={9} className="form-label" style={{ display: "block" }} >
                                        {this.props.t("isPartialChargeback")}
                                        <Field
                                          style={{ marginRight: "5px" }}
                                          className="form-check-input"
                                          display="flex"
                                          name={"isPartialChargeback"}
                                          type="checkbox"
                                        />
                                      </Label>
                                    </div>
                                  </Col>
                                </Row>
                              </fieldset>
                              <ModalHeader
                                style={{
                                  marginTop: "-30px",
                                  marginBottom: "10px",
                                }}
                              ></ModalHeader>
                              <PageModalFooter
                                isEdit={false}
                                isDetail={true}
                                hideAddAnother={true}
                                onCheckboxClick={() => {
                                  this.setState(prevState => ({
                                    addAnother: !prevState.addAnother,
                                  }));
                                }}
                                onCancelClick={() => this.toggle()}
                              />
                            </Form>
                          )}
                        </Formik>
                      </ModalBody>
                    </Modal>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>

      </React.Fragment>

    );
  }
}

ChargebackMonitoring.propTypes = {
  recordList: PropTypes.array,
  onGetRecordList: PropTypes.func,
  className: PropTypes.any,
  apiError: PropTypes.any,
  error: PropTypes.any,
  t: PropTypes.any,
  onGetBankList: PropTypes.func,
  recordBankList: PropTypes.array,
  onGetChargebackStatusList: PropTypes.func,
  recordChargebackStatusList: PropTypes.array
};

const mapStateToProps = ({ chargebackMonitoring, domesticBankDefinition,chargebackStatusDef }) => ({
  recordList: chargebackMonitoring.recordList,
  error: chargebackMonitoring.error,
  recordBankList: domesticBankDefinition.recordList,
  recordChargebackStatusList:chargebackStatusDef.recordList,
});

const mapDispatchToProps = dispatch => ({
  onGetRecordList: record => dispatch(getChargebackMonitoringList(record)),
  apiError: error => dispatch(chargebackMonitoringApiError(error)),
  onGetBankList: record => dispatch(getDomesticBankList(record)),
  onGetChargebackStatusList : () => dispatch(getChargebackStatusDefList())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ChargebackMonitoring));
